export default "__VITE_ASSET__BbASo9hX__"